import { render, staticRenderFns } from "./GradeHistoryItem.vue?vue&type=template&id=c16df256&scoped=true&"
import script from "./GradeHistoryItem.vue?vue&type=script&lang=js&"
export * from "./GradeHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./GradeHistoryItem.vue?vue&type=style&index=0&id=c16df256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16df256",
  null
  
)

export default component.exports